
import * as React from 'react';
import styled from 'styled-components';

import { Modal } from '@process-advisor/process-miner/components/modal/modal';
import { Text} from '@process-advisor/process-miner/modals/text';
import { useApiListener } from '@process-advisor/process-miner/shared/hooks/useApiListener';
import { Event } from '@process-advisor/process-miner/api/events';
import { type StepMetricsModalProps } from '@process-advisor/process-miner/api/methods/modals/stepMetricsModal';
import { getShadow } from '@process-advisor/process-miner/shared/theme';
import { Section } from '@process-advisor/process-miner/modals/section';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

const Wrapper = styled.div`
    display: grid;
    align-items: center;
    grid-template-columns: 200px 300px;
    padding: 5px 5px 5px 5px;
    box-shadow: ${getShadow('pane')};
`;


export const StepMetricsModal = () => {
    const [data, setData] = React.useState<{ fromActivity: string, toActivity: string, avg_comments_customer : number, avg_comments_internal : number, avg_duration : number, avg_worklogs : number, comments_customer : number, comments_internal : number, events : any , tasks: number, max_duration : number, min_duration : number, perc_comments_customer : any , perc_comments_internal : number, perc_total_tasks : number ,perc_worklog : number, std_deviation : number, worklogs : number, time_spent: number, avg_time_spent: number}
    >({ fromActivity: '', toActivity: '', avg_comments_customer : 0, avg_comments_internal : 0, avg_duration : 0, avg_worklogs : 0, comments_customer : 0, comments_internal : 0, events : 0 , tasks: 0, max_duration : 0, min_duration : 0, perc_comments_customer : 0 , perc_comments_internal : 0, perc_total_tasks : 0 ,perc_worklog : 0, std_deviation : 0, worklogs : 0, time_spent: 0, avg_time_spent: 0});
    const [isOpen, setIsOpen] = React.useState(false);

    React.useEffect(() => {

    }, []);
    
    useApiListener(
        Event.openStepMetricsModal,
        ({ data }: StepMetricsModalProps) => {
            setIsOpen(true);
            setData(data);
        }
    );
    const min = 0;

    const onOk = () => {
       console.log('OK')
    };

     return (
        <Modal title='Step Metrics' open={isOpen} onClose={() => setIsOpen(false)} onOk={onOk} width='' showButtons={false} >
            <Wrapper>
                <Section title='From' />
                <Text value={data.fromActivity} width='280px' height='25px'/>

                <Section title='To'/>
                <Text value={data.toActivity} width='280px' height='25px'/>

                <Section title='Tasks'/>
                <Text value={data.tasks} width='100px' height='25px'/>
                <Section title='Events'/>
                <Text value={data.events} width='100px' height='25px'/>
                <Section title='% Total'/>
                <Text value={apiProvider.formatPercentage({perc: data.perc_total_tasks, decimals: 1})} width='100px' height='25px'/>
                <Section title='Avg Duration'/>
                <Text value={apiProvider.formatDuration({ seconds: data.avg_duration })} width='100px' height='25px'/>
                <Section title='Std Deviation'/>
                <Text value={apiProvider.formatDuration({ seconds: data.std_deviation })} width='100px' height='25px'/>
                <Section title='Max Duration'/>
                <Text value={apiProvider.formatDuration({ seconds: data.max_duration })} width='100px' height='25px'/>
                <Section title='Min Duration'/>
                <Text value={apiProvider.formatDuration({ seconds: data.min_duration })} width='100px' height='25px'/>                

                <Section title='Worklogs'/>
                <Text value={apiProvider.formatNumber({ count: data.worklogs })} width='100px' height='25px'/>
                <Section title='Avg Worklogs'/>
                <Text value={apiProvider.formatDecimal({value: data.avg_worklogs, decimals: 1})} width='100px' height='25px'/>
                <Section title='% Tasks - Worklogs'/>
                <Text value={apiProvider.formatPercentage({perc: data.perc_worklog, decimals: 1})} width='100px' height='25px'/>

                <Section title='Total Timespent'/>
                <Text value={apiProvider.formatDuration({ seconds: data.time_spent })} width='100px' height='25px'/>
                <Section title='Avg Timespent'/>
                <Text value={apiProvider.formatDuration({ seconds: data.avg_time_spent })} width='100px' height='25px'/>

            </Wrapper>
        </Modal>
    );
};
